export const storeKeys = {
  // System admin store list
  systemAll: ["system-stores"] as const,
  systemLists: () => [...storeKeys.systemAll, "list"] as const,
  systemList: (params?: Record<string, unknown>) =>
    [...storeKeys.systemLists(), params] as const,
  /** Nested under `systemAll` on purpose: the suspend and reactivate mutations
   *  invalidate `systemAll`, which React Query matches by prefix, so one call
   *  refreshes both the list and an open detail. Deliberately NOT `settings(id)`
   *  — that key has nine merchant consumers on the same `/stores/{id}` path. */
  systemDetail: (id: string) => [...storeKeys.systemAll, "detail", id] as const,
  /** Ranged, so the window is part of the key — otherwise switching from 30d to
   *  7d would serve the 30d figures out of cache under a 7d label. */
  systemAnalytics: (id: string, range: string) =>
    [...storeKeys.systemAll, "analytics", id, range] as const,
  systemHealth: (id: string) =>
    [...storeKeys.systemAll, "health", id] as const,
  // Vendor store settings
  settings: (id: string) => ["store-settings", id] as const,
  /** Nested under `settings(id)` on purpose: the timezone mutation invalidates
   *  `settings(id)`, and React Query matches by prefix, so one call refreshes
   *  both the store record and an open history list. */
  timezoneHistory: (id: string) =>
    [...storeKeys.settings(id), "timezone-history"] as const,
};
